import { ref } from 'vue';

/**
 * Whether the settings sheet is open. One flag near the root, like the
 * sign-out confirmation, so the harbour strip and the battle's top bar open
 * the same sheet without either owning it.
 */
const open = ref(false);

export const settingsOpen = open;

export function openSettings(): void {
  open.value = true;
}

export function closeSettings(): void {
  open.value = false;
}
